import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RelationshipStrengthIndicator, { LEVELS } from '../RelationshipStrengthIndicator';

const LEVEL_LABEL = {
  warm: 'Warm',
  known: 'Known',
  cold: 'Cold',
  inferred: 'Inferred',
  unknown: 'Unknown',
};

const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
  border-radius: 16px;
`;

const Label = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.text.dark};
  white-space: nowrap;
`;

const RelationshipStrengthBadge = ({ level, className }) => {
  // Normalise once so data-level, the indicator, and the label never disagree.
  const normalizedLevel = LEVELS.includes(level) ? level : 'unknown';
  return (
    <Pill className={className} data-level={normalizedLevel}>
      <RelationshipStrengthIndicator level={normalizedLevel} />
      <Label>{LEVEL_LABEL[normalizedLevel]}</Label>
    </Pill>
  );
};

RelationshipStrengthBadge.propTypes = {
  level: PropTypes.oneOf(LEVELS).isRequired,
  className: PropTypes.string,
};

RelationshipStrengthBadge.defaultProps = {
  className: undefined,
};

export default RelationshipStrengthBadge;
